import { el, sv } from "@dhx/ts-common/dom";

declare const require: any;

const icons = {
	rotate: require("./icons/rotate.svg"),
	elbow: require("./icons/elbow.svg"),
	straight: require("./icons/straight.svg"),
	curved: require("./icons/curved.svg"),
	line: require("./icons/line.svg"),
	duplicate: require("./icons/duplicate.svg"),
	connect: require("./icons/connect.svg"),
	plus: require("./icons/plus.svg"),
	minus: require("./icons/minus.svg"),
	"add-line-text": require("./icons/add-line-text.svg"),
	"assistant-add": require("./icons/assistant-plus.svg"),
	"partner-add": require("./icons/account-multiple-plus.svg"),
	"align-bottom": require("./icons/align-bottom.svg"),
	"align-center": require("./icons/align-center.svg"),
	"align-left": require("./icons/align-left.svg"),
	"align-right": require("./icons/align-right.svg"),
	"align-middle": require("./icons/align-middle.svg"),
	"align-top": require("./icons/align-top.svg"),
	"align-horizontal-center": require("./icons/align-horizontal-center.svg"),
	"align-horizontal-left": require("./icons/align-horizontal-left.svg"),
	"align-horizontal-right": require("./icons/align-horizontal-right.svg"),
	"align-vertical-bottom": require("./icons/align-vertical-bottom.svg"),
	"align-vertical-top": require("./icons/align-vertical-top.svg"),
	"align-vertical-middle": require("./icons/align-vertical-middle.svg"),
	"text-shape": require("./icons/text-shape.svg"),
	"image-shape": require("./icons/image-shape.svg"),
	"filled-arrow": require("./icons/filled-arrow.svg"),
	"filled-arrow-rewerse": require("./icons/filled-arrow-rewerse.svg"),
	"change-shape": require("./icons/change-shape.svg"),
	"remove-point": require("./icons/remove-point.svg"),
	"empty-icon": require("./icons/empty-state.svg"),
	"format-text-rotation-angle-up": require("./icons/format-text-rotation-angle-up.svg"),
	"format-text-rotation-none": require("./icons/format-text-rotation-none.svg"),
};

export function getIcon(name: string, css?: string, w = 20, h = 20) {
	// [dirty]
	const base64Svg = icons[name].replace("data:image/svg+xml;base64,", "");

	return el("i", {
		".innerHTML": window.atob(base64Svg),

		class: css || "",
		_key: name,
		style: {
			width: w,
			height: h,
			pointerEvents: "none",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
		},
	});
}

export function addIcon() {
	return sv(
		"svg",
		{
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
		},
		[
			sv("path", {
				// tslint:disable-next-line
				d:
					"M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z",
			}),
		]
	);
}

export function removeIcon() {
	return sv(
		"svg",
		{
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
		},
		[
			sv("path", {
				// tslint:disable-next-line
				d:
					"M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z",
			}),
		]
	);
}
